import styled from "styled-components";
import { AboutBg } from "../../shared/icons";
import { screenSizes } from "../../styles/theme";

export const AboutTopMidSection = styled.div`
  padding: 50px 0;
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: ${screenSizes.S}px) {
      grid-template-columns: repeat(1, 1fr);
    }
    align-items: center;
    list-style: none;
    gap: 50px;
    padding: 0;
    margin: 0;
    li {
      button {
        margin-top: 15px;
      }
      h2 {
        font-weight: 400;
        font-size: calc(1.1vw + 20px);
        color: #1e440b;
        margin-bottom: 20px;
      }
      p {
        font-weight: 400;
        color: #1e440b;
        margin-top: 0;
        line-height: 150%;
        span {
          position: relative;
          padding-left: 15px;

          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 5px;
            background: #fff;
            width: 8px;
            height: 8px;
            border-radius: 50px;
          }
        }
      }
      .one_group_btn {
        display: flex;
        column-gap: 10px;
      }

      &:last-child {
        text-align: center;
      }
    }
    p {
      span {
        position: relative;
        padding-left: 10px;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 7px;
          border-radius: 50px;
          width: 5px;
          height: 5px;
          background: #000;
        }
      }
    }
  }
`;

export const AboutBottomMidSection = styled.div`
  padding: 4rem 6rem;
  @media (max-width: ${screenSizes.M}px) {
    padding: 1rem;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: ${screenSizes.S}px) {
      grid-template-columns: repeat(1, 1fr);
    }
    align-items: center;
    list-style: none;
    gap: 50px;
    padding: 0;
    margin: 0;
    p {
      font-size: 32px;
      line-height: 48px;
      font-weight: 500;
      color: #091C00;
      padding: 2rem;
      @media (max-width: ${screenSizes.M}px) {
        padding: 1rem;
      }
    }
    li {
      button {
        margin-top: 15px;
        border-radius: 80px;
      }
      h2 {
        font-weight: 700;
        font-size: calc(2rem + 18px);
        color: #1e440b;
        margin-bottom: 20px;
        line-height: 64px;
        @media (max-width: ${screenSizes.S}px) {
          font-size: 40px;
          margin-bottom: 0px;
        }
      }
      h5 {
        font-weight: 600;
        font-size: 18px;
        color: #1e440b;
        margin: 0px;
        @media (max-width: ${screenSizes.L}px) {
          font-size: 16px;
        }
      }
      p {
        font-weight: 400;
        color: #091C0080;
        margin-top: 0;
        line-height: 150%;
        font-size: 18px;
        padding: 0;
        @media (max-width: ${screenSizes.S}px) {
          font-size: 16px;
        }
        
        @media (max-width: ${screenSizes.L}px) {
          display: block;
          margin-bottom: 0;
        }
        span {
          position: relative;
          padding-left: 15px;

          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 5px;
            background: #fff;
            width: 8px;
            height: 8px;
            border-radius: 50px;
          }
        }
      }
      div {
        display: flex;
        column-gap: 10px;
        @media (max-width: ${screenSizes.L}px) {
          margin-bottom: 10px;
        }
      }
      &:first-child {
      }
      &:last-child {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 40px;
        @media (max-width: ${screenSizes.L}px) {
          display: block;
        }
      }
    }
    p {
      span {
        position: relative;
        padding-left: 10px;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 7px;
          border-radius: 50px;
          width: 5px;
          height: 5px;
          background: #000;
        }
      }
    }
  }
`;
export const AboutHeroSection = styled.div`
  /* background: url(${AboutBg}) no-repeat center center; */
  .mt {
    margin-top: 0;
  }
  ul {
    li {
      background: transparent !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
`;

export const BottomImageSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 2rem 6rem;
  gap: 58px;
  @media (max-width: ${screenSizes.M}px) {
    display: block;
    padding: 1rem;
  }
  img {
    width: 100%;
    border-radius: 0px 0px 0px 40px;
  }
  h5 {
    margin: 0;
    font-size: 16px;
    text-align: center;
    letter-spacing: 5px;
    padding-top: 10px;
    @media (max-width: ${screenSizes.M}px) {
    font-size: 12px;
  }
    span {
      font-weight: 100;
    }
  }
`;
export const BottomImgContent = styled.div`
  padding-top: 44px;
  h6 {
    margin: 0;
    font-size: 16px;
    position: relative;
    padding-left: 15px;
    margin-bottom: 30px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 6px;
      height: 6px;
      border-radius: 50px;
      background: #ff9d59;
      margin: auto;
    }
  }
  h2 {
    font-size: calc(2rem + 18px);
    line-height: 130%;
    @media (max-width: ${screenSizes.M}px) {
      font-size: 40px;
      letter-spacing: -2px;
    }
  }
  p {
    margin: 0;
    padding: 20px 0px 30px;
    color: #091c00cc;
    @media (max-width: ${screenSizes.M}px) {
    font-size: 16px;
  }
  }
`;

export const SectionWrapper = styled.div`
  padding: 2rem 6rem;
  background-color: #091C001A;
  @media (max-width: ${screenSizes.M}px) {
    padding: 1rem;
  }
  h2 {
    text-align: center;
    font-size: calc(2rem + 18px);
    color: #091c00;
    padding-bottom: 20px;
    @media (max-width: ${screenSizes.M}px) {
    font-size: 40px;
    text-align: left;
    letter-spacing: -2px;
    line-height: 40px;
  }
  }
`;
export const Section = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    gap: 15px;
    padding: 10px;
  }
  @media (max-width: 480px) {
    gap: 12px;
    padding: 8px;
  }
`;
export const CircleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
`;

export const Circle = styled.div<{bgColor: string}>`
  width: 124px;
  height: 124px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
  text-align: center;
  border: 4px solid #fff;
  background: ${(props)=> props.bgColor};
  @media (max-width: 768px) {
    width: 100px; /* Shrink size on tablets */
    height: 100px;
  }

  @media (max-width: 480px) {
    width: 80px; /* Shrink size further on mobile */
    height: 80px;
  }
`;

export const Icon = styled.div`
  svg {
    height: 48px;
    width: 48px;
  }
`;

export const Label = styled.div`
  font-size: 14px;
  color: #000;
  margin-top: 10px;
  font-weight: 500;
`;